import axios from 'axios';
import * as urls from 'constants/urls';

export const getCalendarHandler = ({ payload: { userId, ...params } }) => {
    return axios.get(urls.GET_CALENDAR.stringify({ userId }), { params });
};

export const getCalendarUsers = () => axios.get(urls.GET_CALENDAR_USERS.stringify());

export const createSotrMeet = ({ payload }) => axios.post(urls.CALENDAR_EVENT.stringify(), payload);

export const updateSotrMeet = ({ payload }) => axios.put(urls.CALENDAR_EVENT.stringify({ id: payload.id }), payload);

export const createTask = ({ payload }) => axios.post(urls.CALENDAR_TASK.stringify(), payload);

export const updateTask = ({ payload }) => axios.put(urls.CALENDAR_TASK.stringify({ id: payload.id }), payload);
